module.exports = "/_next/static/resources/photo-4-1b043e9d3a53c579417ba6a905cbd074.webp";